import React, { useState } from 'react';
import {  useDispatch } from 'react-redux';
import { REMOVE_WEB_USER } from '../../../../api/apiRoutes';
import { post } from '../../../../api';
import { logOut } from '../../../../store/auth/authActions';
import { setSuccessMessage } from '../../../../store/alerts/alertsActions';
import useFacility from '../../../../../utils/hooks/useFacility';
import { useTranslation } from 'react-i18next';
import EAButton from '../../../shared/Buttons/EAButton';
import EAModal from '../../../shared/Modal/EAModal';
import { MdDeleteOutline } from 'react-icons/md';
import EAAlert from '../../../shared/EAAlert';

const RemoveWebUserAction: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const facilityIds = useFacility();

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleOpenConfirmation = () => {
    setOpenConfirmation(true);
  };

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };

  const handleRemoveWebUser = async () => {
    setIsDeleting(true);
    const { isError } = await post(REMOVE_WEB_USER(facilityIds));

    if (!isError) {
      dispatch(setSuccessMessage(t('konto_usuniete')));
      dispatch(logOut());
    }

    setIsDeleting(false);
  };

  return (
    <>
      <div className="settings-section">
        <div className="settings-section__header">
          <h5>{t('usun_konto')}</h5>
        </div>

        <div className="settings-section__content">
          <div className="settings-section__actions">
            <EAButton
              title={t('usun_konto')}
              onClick={handleOpenConfirmation}
              color="error"
              variant="filled"
              startIcon={<MdDeleteOutline />}
            />
          </div>
        </div>
      </div>

      {openConfirmation && (
        <EAModal
          isOpen={openConfirmation}
          onClose={handleCloseConfirmation}
          title={t('potwierdzenie_usuniecia_konta')}
          acceptButtonLabel={t('usun_na_zawsze')}
          cancelButtonLabel={t('anuluj')}
          onAccept={handleRemoveWebUser}
          loading={isDeleting}
        >
          <EAAlert message={t('operacja_nie_jest_odwracalna')} type="error" />
        </EAModal>
      )}
    </>
  );
};

export default RemoveWebUserAction;
